import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { api } from "./client";

/**
 * Dashboard counts. Every list endpoint returns `{items, total}` (contract
 * preamble), so `?limit=1` + reading `total` gives a cheap entity count.
 * Keys are `[entity, "count"]` so catalogue mutations (which invalidate
 * `[entity]`) refresh the dashboard automatically.
 */
const TotalOnly = z.object({ total: z.number().int().nonnegative() });

function useListTotal(entity: string, path: string) {
  return useQuery({
    queryKey: [entity, "count"],
    queryFn: () => api.get(path, { query: { limit: 1 }, schema: TotalOnly }),
  });
}

export const useSupplierCount = () => useListTotal("suppliers", "/suppliers");
export const useBrandCount = () => useListTotal("brands", "/brands");
export const useRateCardCount = () => useListTotal("rate-cards", "/rate-cards");
export const useDiscountCount = () => useListTotal("discounts", "/discounts");
export const useProductCount = () => useListTotal("products", "/products");
export const usePriceListCount = () => useListTotal("price-lists", "/price-lists");
export const useComparableGroupCount = () => useListTotal("comparable-groups", "/comparables/groups");
export const useAiJobCount = () => useListTotal("ai-jobs", "/ai-jobs");
